import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100%'
  },

  title: {
    fontSize: theme.size.lg,
    textAlign: 'center',
    color: '#3C425B'
  },

  subtext: {
    marginTop: '16px',
    fontSize: theme.size.base,
    textAlign: 'center',
    color: '#3C425B'
  },

  buttons: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: '16px'
  },

  button: {
    width: '164px',
    height: '48px'
  },

  helperButtonText: {
    textAlign: 'center',
    marginTop: 4,

    '& label': {
      color: 'grey',
      fontSize: theme.size.sm
    }
  },

  noButton: {
    marginRight: '9px'
  },

  yesButton: {
    color: theme.palette.primary.main,
    borderColor: theme.palette.primary.main
  }
}))

export default useStyles
